import React, { Fragment } from "react";
import { connect } from "react-redux";
import Navbar from "../../components/Navbar/Navbar";
import Scrollbar from "../../components/scrollbar/scrollbar";
import {
  addToCart,
  addToCompareList,
  decrementQuantity,
  incrementQuantity,
  removeFromCart,
} from "../../store/actions/action";
import Product from "./product";
import Footer from "../../components/footer/Footer";

const ProductSinglePage = (props) => {
  const addToCartProduct = async (product, qty = 1) => {
    await props?.addToCart(product, qty);
  };

  return (
    <Fragment>
      <Navbar />
      <div className="gpps-page">
        <Product {...props} addToCartProduct={addToCartProduct} />
      </div>
      <Footer />
      <Scrollbar />

      <style>{`
        .gpps-page {
          background: linear-gradient(180deg, #0b0b0c 0%, #07060a 100%);
          color: #fff;
          min-height: 70vh;
        }
      `}</style>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  products: state.data.products,
  carts: state.cartList.cart,
  w_list: state.wishList.w_list,
  configs: state.configs,
  token: state.configs.token,
});

export default connect(mapStateToProps, {
  addToCart,
  addToCompareList,
  removeFromCart,
  decrementQuantity,
  incrementQuantity,
})(ProductSinglePage);
